
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/today-new/[[...pathParams]]",
      function () {
        return require("private-next-pages/landing/today-new/[[...pathParams]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/today-new/[[...pathParams]]"])
      });
    }
  